(function () {
  const SWYM_NOTIFICATION_SELECTOR = '#swym-storefront-layout-notification';
  const GO_TO_CART_TEXT = 'go to cart';

  let triggered = false;

  function hasGoToCartButton(el) {
    for (const btn of el.querySelectorAll('button')) {
      if (btn.textContent.trim().toLowerCase() === GO_TO_CART_TEXT) {
        return true;
      }
    }
    return false;
  }

  function isVisible(el) {
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity) > 0
    );
  }

  function triggerCartUpdate() {
    if (!window.themeCore || !window.themeCore.CartApi) return;
    window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
  }

  function checkNotification() {
    const notification = document.querySelector(SWYM_NOTIFICATION_SELECTOR);

    if (!notification) {
      triggered = false;
      return;
    }

    const visible = isVisible(notification) && hasGoToCartButton(notification);

    if (visible && !triggered) {
      triggered = true;
      triggerCartUpdate();
    } else if (!visible) {
      triggered = false;
    }
  }

  const observer = new MutationObserver(checkNotification);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
})();
